export default function ($) {
  const burgerButton = window.document.querySelector('.c-hamburger');
  const menuParent = window.document.querySelectorAll('.navd .menu-parent');
  const menuChildren = window.document.querySelectorAll('.navd .menu-children');
  const menuImageSource = window.document.querySelectorAll('.navd .menu-link');
  const menuImageTarget = window.document.querySelectorAll('.navd .menu-image');
  const menuFooterLinks = document.querySelectorAll('.navd__nav--foot a');
  const navPropertyContainer = document?.querySelector('.navp__container');

  let ch = 0;

  /**
   * Reset
   * Remove all active classes
   *
   * @return void
   */
  function reset() {
    menuParent.forEach((item) => {
      item.classList.remove('current');
    });

    menuChildren.forEach((item) => {
      item.classList.remove('animate');
      setTimeout(() => {
        item.classList.remove('open');
      }, 100);
    });
  }

  /**
   * menuRollOfEffect
   *
   * @return void
   */
  function menuRollOfEffect() {
    const transition = window.document.querySelectorAll('.navd__col');

    if (!burgerButton.classList.contains('open')) {
      transition.forEach((item) => {
        setTimeout(() => {
          item.classList.add('animate');
        }, 70);
      });

      if (window.innerWidth >= 992 && navPropertyContainer !== null) {
        navPropertyContainer.style.visibility = 'hidden';
      }
    }
    if (burgerButton.classList.contains('open')) {
      transition.forEach((item) => {
        item.classList.remove('animate');
      });

      if (window.innerWidth >= 992 && navPropertyContainer !== null) {
        navPropertyContainer.removeAttribute('style');
      }
    }
  }

  /**
   * autoHeight
   * Adjust menu's container height
   *
   * @return void
   */
  function autoHeight() {
    const c = window.document.querySelectorAll('.navd__row');
    const n = window.document.querySelector('.navd__menu');
    const m = window.document.querySelector('.menu-children');
    if (n.clientHeight > ch) {
      ch = n.clientHeight + m.clientHeight + 40;
    }
    c.forEach((item) => {
      const cItem = item;
      cItem.style.height = `${ch}px`;
    });
  }

  /**
   * Tab init
   * Set first menu to active state
   *
   * @return void
   */
  function tabInit() {
    reset();

    const mp = window.document.querySelector('.menu-parent');
    if (!mp) {
      return;
    }
    const dp = mp.getAttribute('data-parent');
    const cn = window.document.getElementById(dp);

    mp.classList.add('current');

    if (!cn) {
      return;
    }

    setTimeout(() => {
      cn.classList.add('open');
      cn.classList.add('animate');
      autoHeight();
    }, 100);
  }

  /**
   * Menu image init
   *
   * @param id
   * @return @void
   */
  function menuImageInit(id) {
    const groups = window.document.querySelectorAll('.group-image');

    groups.forEach((item, index) => {
      $(item).find('.menu-image').animate({ opacity: 0 }, 300, 'linear');
      if (id && (id === item.id)) {
        $(item).find('.menu-image:first-child').show().stop()
          .animate({ opacity: 1 }, 300, 'linear');
      } else if (index === 0) {
        $(item).find('.menu-image:first-child').show().stop()
          .animate({ opacity: 1 }, 300, 'linear');
      }
    });
  }

  /**
   * Tab change
   *
   * @param el
   */
  function tabChange(el) {
    reset();

    const dp = el.getAttribute('data-parent');
    const gi = el.getAttribute('data-group-image');
    const cn = window.document.getElementById(dp);

    menuImageInit(gi);

    el.classList.add('current');

    if (!cn) {
      return;
    }

    setTimeout(() => {
      cn.classList.add('open');
      cn.classList.add('animate');
      autoHeight();
    }, 100);
  }

  /**
   * Menu image show
   *
   * @param el
   * @return {boolean}
   */
  function menuImageChange(el) {
    const dg = el.getAttribute('data-group-image');
    const gi = window.document.getElementById(dg);

    if (!gi) {
      return false;
    }

    menuImageTarget.forEach((item) => {
      $(item).stop().animate({ opacity: 0 }, 300, 'linear', () => {
        if ($(item).id === dg) {
          return;
        }
        $(item).hide();
      });
    });

    $(`#${dg}`).show().stop().animate({ opacity: 1 }, 300, 'linear', () => {
      $(`#${dg}`).stop(true);
    });
    return true;
  }

  menuParent.forEach((item) => {
    item.addEventListener('click', (event) => {
      if (!item.classList.contains('current')) {
        tabChange(event.target);
      }
    });
  });

  menuImageSource.forEach((item) => {
    item.addEventListener('mouseenter', (event) => {
      menuImageChange(event.target);
    });
  });

  burgerButton.addEventListener('click', () => {
    menuRollOfEffect();

    if (!burgerButton.classList.contains('open')) {
      tabInit();
      menuImageInit();
    }
  });

  function addAdaFocusLoopInsideMenu() {
    const lastMenuFooterLinkIndex = menuFooterLinks.length - 1;
    const lastMenuFooterLink = menuFooterLinks[lastMenuFooterLinkIndex];
    lastMenuFooterLink.addEventListener('focusout', () => {
      burgerButton.focus();
    });
  }

  window.addEventListener('resize', () => {
    tabInit();
  });

  window.addEventListener('load', () => {
    tabInit();
    addAdaFocusLoopInsideMenu();
  });
}
